import {Box, Grid, Typography} from '@mui/material';
import {BaseCard} from 'components/card';
import {AppTooltip} from 'components/toolip';
import {AppEllipsisTypography} from 'components/typographies';
import {NotificationModel, NotificationStatus} from 'models';
import {IoNotificationsCircleOutline} from 'react-icons/io5';
import {RiCheckDoubleFill} from 'react-icons/ri';
import {useNavigate} from 'react-router-dom';
import parser from 'html-react-parser';

interface NotificationCardProps {
    notification: NotificationModel;
    handleMarkAsRead: (ids: string[]) => void;
}

export const NotificationCard: React.FC<NotificationCardProps> = ({notification, handleMarkAsRead}) => {
    const navigate = useNavigate();
    const hasHTML = (html: string) => /<[^>]+>/.test(html);
    const handleUrlNavigate = () => {
        if (notification.status === NotificationStatus.UNREAD) {
            handleMarkAsRead([notification.id]);
        }
        if (notification.url) {
            navigate(notification.url);
        }
    };
    return (
        <Grid item xs={12} key={notification.id}>
            {/* <IoNotificationsCircleOutline /> */}
            <BaseCard
                cardProps={{
                    hoverEffect: true,
                    onClick: handleUrlNavigate,
                }}
                // dateTime={notification.createdDate}
                headerData={
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="subtitle2" color="text.secondary">
                            {notification.title}
                        </Typography>

                        {notification.status !== NotificationStatus.UNREAD && (
                            <AppTooltip title="Read">
                                <RiCheckDoubleFill size={15} color="#386aff" />
                            </AppTooltip>
                        )}
                    </Box>
                }
                icon={<IoNotificationsCircleOutline size={30} color="#386aff" />}
                footerData={
                    <div>
                        {notification.data && hasHTML(notification.data) ? (
                            <div>{parser(notification.data ?? '<></>')}</div>
                        ) : (
                            <AppEllipsisTypography
                                variant="body2"
                                text={notification.data ?? ''}
                                hideDetails
                                whiteSpace="normal"
                                maxLetters={150}
                            />
                        )}
                    </div>
                }
            />
        </Grid>
    );
};

export default NotificationCard;
